import React from "react";
import styled from "styled-components";
import { MdAdd, MdSend } from "react-icons/md";
import { IChat } from "../../interfaces/chat";
import { useUser } from "../../store/UserStore";
import { useHistory } from "react-router-dom";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import firebase from "firebase";
import { sendChatMessage } from "../../services/chat.service";
import { useError } from "../../store/ErrorModal";
import { GetErrorMessage } from "../../functions/error";
export const ContainerCard = styled.div`
  flex: 1;
  height: calc(100vh - 4rem);
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.01);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  margin: 2rem 0rem;
`;

const ContainerChat = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 2rem;
  padding-bottom: 3rem;

  &::-webkit-scrollbar {
    display: none;
  }
`;

interface Props {
  booking?: IPaymentTracking;
}

const ChatContent = (props: Props) => {
  const messagesEndRef = React.useRef(null);
  const db = firebase.firestore().collection("chats");
  const [message, setMessage] = React.useState<string>("");
  const [chats, setChats] = React.useState<IChat[]>([]);
  const { onError } = useError();
  const user = useUser();
  const history = useHistory();
  const scrollToBottom = () => {
    if (!messagesEndRef.current) return;
    //@ts-ignore
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  React.useEffect(scrollToBottom, []);
  React.useEffect(() => {
    if (!props.booking?.uid) return;
    const unsubscribe = db
      .doc(props.booking?.uid)
      .collection("chat")
      .orderBy("timestamp", "asc")
      .onSnapshot((snap) => {
        const newChat: IChat[] = [];
        snap.docChanges().forEach((change) => {
          if (change.type === "added") {
            const chat = { ...change.doc.data(), id: change.doc.id } as IChat;
            newChat.push(chat);
          }
        });
        if (snap.docChanges().length > 0) setChats(newChat);
      });
    //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
    return () => unsubscribe();
  }, [db, props.booking]);

  const handleSendMessage = async () => {
    if (!user.userData) return history.replace("/login");
    if (!message) return;
    if (!props.booking) return;
    const newChat: IChat = {
      uid: props.booking?.uid,
      timestamp: new Date().getTime(),
      text: message,
      type: "text",
      doctorId: user.userData.uid,
    };
    try {
      const result = await sendChatMessage(newChat);
      newChat.id = result.data.id;
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setMessage("");
    setChats([...chats, newChat]);
    scrollToBottom();
  };
  return props.booking ? (
    <ContainerCard>
      <ContainerChat>
        {chats.map((item) => (
          <Chat
            text={item.text}
            blob={item.blob}
            key={item.id}
            isMe={item.doctorId}
          />
        ))}
        <div style={{ padding: "0.1rem" }} ref={messagesEndRef} />
      </ContainerChat>
      <ChatInputBar
        message={message}
        setMessage={setMessage}
        handleSendMessage={handleSendMessage}
      />
    </ContainerCard>
  ) : (
    <></>
  );
};

const InputBar = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 1rem;
  background: #f2f2f2;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
`;

const Input = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
`;

const ContainerAddFile = styled.div`
  border-radius: 999rem;
  padding: 0.5rem;
  background: #f2f2f2;
  margin: 0.55rem;
  margin-left: 0rem;
  cursor: pointer;
  aspect-ratio: 1;
`;

const ContainerInput = styled.form`
  display: flex;
  width: 100%;
`;
interface IChatInputBar {
  message: string;
  setMessage(message: string): void;
  handleSendMessage: () => void;
}
const ChatInputBar = (props: IChatInputBar) => {
  return (
    <ContainerInput
      onSubmit={(e) => {
        e.preventDefault();
        props.handleSendMessage();
      }}
    >
      <InputBar>
        <Input
          value={props.message}
          onChange={(e) => props.setMessage(e.target.value)}
          placeholder="ข้อความ"
        />
      </InputBar>
      <ContainerAddFile onClick={props.handleSendMessage}>
        <MdSend size={24} />
      </ContainerAddFile>
      <ContainerAddFile>
        <MdAdd size={24} />
      </ContainerAddFile>
    </ContainerInput>
  );
};

const Buble = styled.div`
  background: #f2f2f2;
  border-radius: 1rem;
  margin: 0.25rem;
  align-self: flex-start;
  max-width: 300px;
  ${({ isme }: { isme?: boolean }) =>
    isme &&
    ` align-self: flex-end;
      margin-left: auto;
      background-color: #123559;`}
`;
const TextChat = styled.p`
  margin: 0;
  padding: 0.5rem 1rem;
  word-wrap: break-word;
  ${({ isme }: { isme?: boolean }) => isme && `color: white;`}
`;
const ImageChat = styled.img`
  width: 240px;
  height: auto;
  border-radius: 1rem;
`;
const ContainerBuble = styled.div`
  display: flex;
  width: 100%;
`;
interface IChatProps {
  url?: string;
  blob?: Blob;
  text?: string;
  isMe?: boolean;
  avatarUser?: string;
}
const Chat = (props: IChatProps) => {
  return (
    <ContainerBuble>
      {!props.isMe && props.avatarUser && (
        <img
          alt="alvatar"
          src={props.avatarUser}
          style={{
            width: "1.5rem",
            height: "1.5rem",
            borderRadius: "9999px",
            marginTop: "0.25rem",
          }}
        />
      )}
      <Buble isme={props.isMe}>
        {props.text && <TextChat isme={props.isMe}>{props.text}</TextChat>}
        {props.url && <ImageChat src={props.url} />}
      </Buble>
    </ContainerBuble>
  );
};

export default ChatContent;
